// font
import "../src/Assets/fonts/fonts.scss";
// Bootstrap
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
// Global style
import "./Assets/style/global/index.scss";
// Other
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./Redux/store";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
